import { Injectable } from "@angular/core";
import { LoginService } from "./login.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { BACKEND_URI } from "../config/config-vars";
import { BoardType } from "../models/board-type.model";

const BASE_URL = `${BACKEND_URI}/api/boardType`;
const GET_ALL_URL = BASE_URL;
const INSERT_URL = BASE_URL;
const UPDATE_URL = (id) => `${BASE_URL}/${id}`;
const GET_BY_ID_URL = (id) => `${BASE_URL}/${id}`;
const DELETE_BY_ID_URL = (id) => `${BASE_URL}/${id}`;

@Injectable({providedIn: 'root'})
export class BoardTypeService {
    constructor(private http: HttpClient, private loginService: LoginService){}
    
    async getAll(): Promise<BoardType[]> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.get<BoardType[]>(GET_ALL_URL)
            );
        }
    }

    async getById(id): Promise<BoardType> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.get<BoardType>(GET_BY_ID_URL(id))
            );
        }
    }
    async create(data: BoardType): Promise<BoardType> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.post<BoardType>(INSERT_URL, data)
            );
        }
    }
    async update(id, data: BoardType): Promise<BoardType> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.put<BoardType>(UPDATE_URL(id), data)
            );
        }
    }


    async delete(id): Promise<void> {
        if(this.loginService.isloggedIn) {
            try{
                await firstValueFrom(
                    this.http.delete(DELETE_BY_ID_URL(id))
                );
            }catch(err) {}
            } 
        }      
    }